import { render, staticRenderFns } from "./VersionPanel.vue?vue&type=template&id=4714891e&scoped=true"
import script from "./VersionPanel.vue?vue&type=script&lang=ts"
export * from "./VersionPanel.vue?vue&type=script&lang=ts"
import style0 from "./VersionPanel.vue?vue&type=style&index=0&id=4714891e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4714891e",
  null
  
)

export default component.exports